import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { MarketingReportKpis } from '@/lib/api/marketing-report-service';
import { Users, TrendingUp, Eye, MousePointer, Target } from 'lucide-react';

interface Props { kpis: MarketingReportKpis; }

function KpiCard({
  label,
  value,
  icon: Icon,
}: {
  label: string;
  value: string | number;
  icon: React.ElementType;
}) {
  return (
    <Card>
      <CardContent className="pt-4 pb-4">
        <div className="flex items-center gap-3">
          <Icon className="h-5 w-5 text-muted-foreground shrink-0" />
          <div>
            <p className="text-xs text-muted-foreground">
              {label}
            </p>
            <p className="text-2xl font-semibold">{value}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function MarketingMetricsStrip({ kpis }: Props) {
  const engagementPct = `${Math.round(kpis.engagementRate * 100)}%`;
  return (
    <div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        <KpiCard label="Total Sessions" value={kpis.totalSessions.toLocaleString()} icon={Users} />
        <KpiCard label="Engaged Sessions" value={kpis.engagedSessions.toLocaleString()} icon={MousePointer} />
        <KpiCard label="Engagement Rate" value={engagementPct} icon={TrendingUp} />
        <KpiCard label="Unique Visitors" value={kpis.uniqueVisitors.toLocaleString()} icon={Users} />
        <KpiCard label="Pageviews" value={kpis.pageviews.toLocaleString()} icon={Eye} />
        {/* The outcome, last so the strip reads traffic -> engagement -> result. */}
        <KpiCard label="Leads Generated" value={kpis.leads.toLocaleString()} icon={Target} />
      </div>
    </div>
  );
}
